import { IComponentOptions } from 'angular';
import { SupportDuplicationCtrl } from '../support-duplicator/support-duplicator.controller';

export const SupportDuplicationComponent: IComponentOptions = {
  template: require('../support-duplicator/support-duplicator.html'),
  bindings: {
    supportId: '<',
    browserTab: '<',
  },
  controller: SupportDuplicationCtrl,
};
